// extracted by mini-css-extract-plugin
export var wrapper = "about-module--wrapper--27jkM";
export var heading = "about-module--heading--3_852";